import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingState } from '@atlassian/notification-common/types';
var mergePaginatedNotifications = function mergePaginatedNotifications(currentNotifications, newNotifications) {
  var newNotificationsMap = newNotifications.reduce(function (indexes, notif) {
    indexes.set(notif.id, notif);
    return indexes;
  }, new Map());
  var currentIndexesMap = currentNotifications.reduce(function (indexes, notif) {
    indexes.set(notif.id, notif);
    return indexes;
  }, new Map());
  var updatedCurrentNotifications = currentNotifications.map(function (notification) {
    var _updateNotificationDo;
    return (_updateNotificationDo = updateNotificationDocuments(notification, newNotificationsMap.get(notification.id))) !== null && _updateNotificationDo !== void 0 ? _updateNotificationDo : notification;
  });
  var notificationsToAdd = newNotifications.filter(function (newNotification) {
    var exists = !!currentIndexesMap.get(newNotification.id);
    return !exists;
  });
  return updatedCurrentNotifications.concat(notificationsToAdd).sort(function (a, b) {
    return a.timestamp < b.timestamp ? 1 : -1;
  });
};
var getUpdatedBody = function getUpdatedBody(currentNotification, updatedNotification) {
  var _currentNotification$, _currentNotification$2;
  if (!(updatedNotification !== null && updatedNotification !== void 0 && updatedNotification.content.body)) {
    return undefined;
  }
  if ((updatedNotification === null || updatedNotification === void 0 ? void 0 : updatedNotification.content.body.items.length) > ((_currentNotification$ = currentNotification === null || currentNotification === void 0 || (_currentNotification$2 = currentNotification.content.body) === null || _currentNotification$2 === void 0 ? void 0 : _currentNotification$2.items.length) !== null && _currentNotification$ !== void 0 ? _currentNotification$ : -Infinity)) {
    return {
      body: updatedNotification.content.body
    };
  }
  return {
    body: currentNotification.content.body
  };
};
export var updateNotificationDocuments = function updateNotificationDocuments(currentNotification, updatedNotification) {
  if (!updatedNotification) {
    return null;
  }
  if (currentNotification.loadingState === LoadingState.COMPLETE) {
    return currentNotification;
  }
  return _objectSpread(_objectSpread({}, currentNotification), {}, {
    content: _objectSpread(_objectSpread({}, currentNotification.content), getUpdatedBody(currentNotification, updatedNotification)),
    loadingState: updatedNotification.loadingState
  });
};
export default mergePaginatedNotifications;